import React from "react";
import { useTranslation } from "react-i18next";
import {
    StyledModal,
    StyledH2,
    StyledLabel,
} from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useSnapshot } from "valtio";

import { store } from "../../../../components/VerticalLayout/store";
import {
    store as logoStore,
    setNumberActive,
    setNumberArchived,
} from "../store";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { confirmationActiveLogo } from "./hooks";
import { useFetchGlobal } from "../../../../api/hooks";

type ConfirmationDeleteMessageType = {
    setIsModalConfirmationOpened: Function;
    isModalConfirmationOpened: boolean;
    selectedRows: any;
};

export function ConfirmationActiveLogo({
    setIsModalConfirmationOpened,
    isModalConfirmationOpened,
    selectedRows,
}: ConfirmationDeleteMessageType) {
    const { t } = useTranslation();
    const { userID, franchiseID, operatorID } = useSnapshot(store);
    const { numberActive, numberArchived, shopsLogoData } = useSnapshot(
        logoStore
    );
    const uuidUser = localStorage.getItem("uuidUser");
    const { fetchGlobal } = useFetchGlobal();
    function ArchivedLogo(e: any) {
        let idsAssociated = ["0"];
        if (shopsLogoData !== undefined) {
            shopsLogoData.forEach((element: any) => {
                element.subRows.forEach((el: any) => {
                    if (el.Id === e.Id) idsAssociated.push(el.shopId);
                });
            });
        }
        idsAssociated = [...new Set(idsAssociated)];

        return idsAssociated;
    }
    return (
        <StyledModal toggle={true} isOpen={isModalConfirmationOpened!} centered>
            <ModalHeader
                className="text-capitalize"
                toggle={() =>
                    setIsModalConfirmationOpened(!isModalConfirmationOpened)
                }
            >
                <StyledH2 className="text-uppercase">{t("Alert")}</StyledH2>
            </ModalHeader>
            <ModalBody>
                <StyledLabel className="pl-3 m-0">
                    {t(
                        "Attention! the logo is archived at store level. Do you want to activate it in shops too?"
                    )}
                </StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0">
                <CustomSecondaryColorButton
                    outline
                    variant="light"
                    onClick={() => {
                        confirmationActiveLogo(false,selectedRows,ArchivedLogo,userID,franchiseID,operatorID,uuidUser,fetchGlobal);
                        setIsModalConfirmationOpened(
                            !isModalConfirmationOpened
                        );
                    }}
                    rounded
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    className="mr-2"
                    variant="primary"
                    onClick={() => {
                        confirmationActiveLogo(true,selectedRows,ArchivedLogo,userID,franchiseID,operatorID,uuidUser,fetchGlobal)
                        setIsModalConfirmationOpened(
                            !isModalConfirmationOpened
                        );
                        setNumberActive(
                            selectedRows.length !== 0
                                ? numberActive + selectedRows.length
                                : numberActive + 1
                        );
                        setNumberArchived(
                            selectedRows.length !== 0
                                ? numberArchived - selectedRows.length
                                : numberArchived - 1
                        );
                    }}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
